import React from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "antd";
import { PercentageOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import TaxRateForm from "./form";

export default function TaxRateUpdate() {
  const { id } = useParams();
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Tax Rates", path: "/billing/tax-rates" },
          { label: "Edit", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <PercentageOutlined /> }}
        title="Edit Tax Rate"
        style={{ marginBottom: 16 }}
      />
      <TaxRateForm id={id} />
    </div>
  );
}
